var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartRecord = function SvgStartRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "startRecord_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M219.433 512.005a314.07 314.07 0 0 0 146.302 255.997 280.62 280.62 0 0 0 292.563 0A295 295 0 0 0 804.6 512.005a304.25 304.25 0 0 0-146.302-255.998 280.62 280.62 0 0 0-292.563 0 304.25 304.25 0 0 0-146.302 255.998M511.995.01a511.995 511.995 0 1 0 511.995 511.995A508.84 508.84 0 0 0 511.995.01m0 950.86A438.865 438.865 0 1 1 950.86 512.005 440.145 440.145 0 0 1 511.995 950.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M219.433 512.005a314.07 314.07 0 0 0 146.302 255.997 280.62 280.62 0 0 0 292.563 0A295 295 0 0 0 804.6 512.005a304.25 304.25 0 0 0-146.302-255.998 280.62 280.62 0 0 0-292.563 0 304.25 304.25 0 0 0-146.302 255.998M511.995.01a511.995 511.995 0 1 0 511.995 511.995A508.84 508.84 0 0 0 511.995.01m0 950.86A438.865 438.865 0 1 1 950.86 512.005 440.145 440.145 0 0 1 511.995 950.87"
  })));
};
export default SvgStartRecord;